import Parse from "parse";

export default function ParseConfig() {
  const PARSE_APP_ID = process.env.VUE_APP_PARSE_APP_ID;
  const PARSE_JS_KEY = process.env.VUE_APP_PARSE_JS_KEY;
  const PARSE_SERVER_URL = process.env.VUE_APP_PARSE_SERVER_URL;

  Parse.initialize(PARSE_APP_ID, PARSE_JS_KEY);
  Parse.serverURL = PARSE_SERVER_URL;
}
